module.exports = __webpack_public_path__ + "static/media/train.eb6dc593.svg";